// @ts-check
import { th } from "intl-tel-input/i18n";
import { Category } from "./category";
import { PageBuilder } from "./page-builder";
import { Widget } from "./widget";
export class Post{
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];
this.m = this.main = main;//used when using this component to create another
this.state = state;
this.title = "post";
/**@type {any|null}*/this.postViewDto = null;//guest
/**@type {number}*/this.homePageId;
/**@type {any[]|null}*/this.posts$ = null;
/**@type {any|null}*/this.post$ = null;
//list
/**@type {any[]|null}[*/this.categories$ = null;
/**@type {any|null}*/this.category$ = null;
/**@type {string[]}*/this.categoryTitles = [];
//
/**@type {string[]|null}*/this.postTags = [];
/**@type {string[]}*/this.postKeywords = [];
//used components
/**@type {any}*/this.pb = new PageBuilder(this.main,this);//pageBuilder
this.widget = new Widget(main,this);
this.headerTemplate = null;
this.footerTemplate = null;
this.isView = false;//??
//Filtering
this.categoryFilterTerm = 'all';
this.statusFilterTerm = 'all';
//displaying archives
this.archiveTitle = '';
/**@type {any[]|null}*/this.postArchive$ = null;
//for troubleshooting
this.count = 0;
this.subscribeText = 'If you have not yet subscribed to our newsletter, kindly do so today.';
}//

async setDisplay(){
   //step 1
if(this.state.stateObject){
this.categories$ = this.state.stateObject.categories;
this.categoryTitles = this.categories$.map(c=>c.title);
if(this.state.type=='list'){
    this.posts$ = this.state.stateObject.posts;
    for(let p of this.posts$){
    //set category
    for(let c of this.categories$){
        if(p.categoryId==c.id){
            p.category = c;
            break;
        }
    }
    //set author
}
this.main.log(this.posts$,'Post.setDisplay(): processed posts');
    //note: categories is sent wether list or new or edit
    }else if(this.state.type=='new'){
        this.post$ = this.getNewPost();
    }else if(this.state.type=='edit'){
        this.post$ = this.state.stateObject.post;
        for(let c of this.categories$){
        if(this.post$.categoryId==c.id){
            this.post$.category = c;
            break;
        }
    }
    }
//

}

}//func

   
async getListTemplate(){
await this.setDisplay();
let $this = this;
let isPost = this.state.postType=='post';
this.postFormSection=this.main.pbu.createElement('main',['post']);
this.main.pbu.appendChild(this.postFormSection,
`
<section>
<div class="container">
<header class="my-2">
<a type="button" href="${this.main.getLink('post',this.state.postType,'new',-1)}" class="btn btn-primary new-post sp-admin sp-route-link">Add ${this.state.postType} </a> 
</header>

<div class="filter filter-by-status w-25">
  <ul class="sp-active-list list-group list-group-horizontal">
  <li class="list-group-item list-group-item-action sp-nav-link sp-active filter-by-status" style="cursor: pointer;" data-status="All">All</li>
  <li class="list-group-item list-group-item-action sp-nav-link filter-by-status" style="cursor: pointer;" data-status="publish">Published</li>
  <li class="list-group-item list-group-item-action sp-nav-link filter-by-status" style="cursor: pointer;" data-status="draft">Draft</li>
</ul>
</div>

<div class="filter filter-by-category w-25 ${this.main.pbu.showIf(isPost )}">
<p>Filter by category</p>
${this.main.pbu.createSelectElement({value:this.categoryFilterTerm,default:'All',postItems:[...this.categories$],clasz:['filter-by-category'],serialize:true})}
</div>

<div class="d-flex justify-content-end">
<form class="row g-3">
<div class="col-auto sp-form-control">
<input class="form-control search-term" placeholder="search">
</div>
<div class="col-auto">
<button id="searchPostsButton" type="button" class="btn btn-primary mb-3">Search</button>
</div>
</form>
</div>

<section class="list-table post-list-table"></section>

</section>
`
);
//only for postType = post
this.filterPostsByCategoryDiv = null;
this.filterPostsByCategorySelector = null;
this.searchTermControl = this.postFormSection.querySelector('input.search-term');
this.searchPostsButton = this.postFormSection.querySelector('#searchPostsButton');
this.postListTableSection = this.postFormSection.querySelector('.post-list-table'); 

//now
await updateView();
addEvents();
return this.postFormSection;
async function updateView(){
$this.setListTable(null);
///
}//inner
async function addEvents(){
let filterPostsByStatusButtons = $this.postFormSection.querySelectorAll('li.filter-by-status');
let statusFilterTerm;
for(let cs of filterPostsByStatusButtons){
$this.main.pbu.listen(cs,'click',()=>{
    statusFilterTerm = cs.getAttribute('data-status');
    $this.filterPosts(statusFilterTerm,'status');
    $this.m.pbu.addActiveClass(cs);
});
}//for
//
if(isPost){
$this.filterPostsByCategoryDiv = $this.postFormSection.querySelector('.filter-by-category');
$this.filterPostsByCategorySelector = $this.postFormSection.querySelector('select.filter-by-category');
$this.main.pbu.listen($this.filterPostsByCategorySelector,'change',()=>{
    let categoryFilterTerm = $this.filterPostsByCategorySelector.options[$this.filterPostsByCategorySelector.selectedIndex].text;
    $this.filterPosts(categoryFilterTerm,'category');
},$this);
}

//
$this.main.pbu.listen($this.searchPostsButton,'click',()=>{
    let searchTerm = $this.searchTermControl.value;
    //validate();
    $this.searchPostList(searchTerm);
},$this);
//

}//inner
}//func
async getFormTemplate(){
await this.setDisplay();
let $this = this;
let p = this.post$;
this.postFormSection=this.main.pbu.query('#postFormSection').cloneNode(true);
this.main.pbu.show(this.postFormSection);
//main form ie build section for page builder
this.postForm = this.postFormSection.querySelector('#postForm');
this.postTitleControl = null;//set later in updateView();
this.mainContentDiv = this.postForm.querySelector('.main-content');
//only for products
this.productDataDiv = this.postFormSection.querySelector('.product-data');
this.regularPriceControl = this.postFormSection.querySelector('.regular-price');
this.salesPriceControl = this.postFormSection.querySelector('.sales-price');
//general
//content status
this.contentStatusSection = this.postFormSection.querySelector('section.content-status');
this.contentStatusDiv = this.contentStatusSection.querySelector('div.content-status');
//sidebar
this.sidebarTypeSection = this.postFormSection.querySelector('section.sidebar-type');
this.sidebarTypeDiv = this.sidebarTypeSection.querySelector('div.sidebar-type');
//sidebarWidgets
this.sidebarWidgetsSection = this.postFormSection.querySelector('section.sidebar-widgets');
this.recentPostsWidgetControl = this.sidebarWidgetsSection.querySelector('#recentPostsWidgetControl');
this.recentPostsWidgetSettingsDiv = this.sidebarWidgetsSection.querySelector('#recentPostsWidgetSettings');
//image
this.featuredImageSection = this.postFormSection.querySelector('section.featured-image');
//excerpt
this.excerptSection = this.postFormSection.querySelector('section.excerpt');
this.excerptButton = this.excerptSection.querySelector('button.excerpt');
//	category
this.postCategoriesSection = this.postFormSection.querySelector('section.post-categories');
this.postCategoriesDiv = this.postCategoriesSection.querySelector('div.post-categories');
this.categoryTitleSelector = null;//created in renderCategories();
this.createCategoryButton = this.postCategoriesSection.querySelector('a.create-category');


//keywords

//sibebar type
this.sidebarTypeSection = this.postFormSection.querySelector('section.sidebar-type');
this.sidebarTypeDiv = this.sidebarTypeSection.querySelector('div.sidebar-type');
//not yet populated, populated in updateView();
this.sidebarTypeSelector = null;
//advance section
this.isFeaturedSection = this.postFormSection.querySelector('section.is-featured');
this.main.pbu.replace(this.isFeaturedSection,
this.main.pbu.createCheckedInputElement({value:p.isFeatured,isBool:true,clasz:['is-featured'],divClasz:['form-switch'],items:['Featured?']})
//this.main.pbu.createCheckedInputElement({value:p.isFeatured?'Featured?':'',clasz:['is-featured'],divClasz:['form-switch'],items:['Featured?']})
);
this.isFeaturedControl = this.isFeaturedSection.querySelector('input.is-featured');
//
this.isStickySection = this.postFormSection.querySelector('section.is-sticky');
this.main.pbu.replace(this.isStickySection,
this.main.pbu.createCheckedInputElement({value:p.isSticky,isBool:true,clasz:['is-sticky'],divClasz:['form-switch'],items:['Sticky?']})
);
this.isStickyControl = this.isStickySection.querySelector('input.is-sticky');
//
this.allowCommentsSection = this.postFormSection.querySelector('section.allow-comments');
this.main.pbu.replace(this.allowCommentsSection,
this.main.pbu.createCheckedInputElement({value:p.allowComments,isBool:true,clasz:['allow-comments'],divClasz:['form-switch'],items:['Allow Comments?']})
);
this.allowCommentsControl = this.allowCommentsSection.querySelector('input.allow-comments');
//
this.showSubscribeSection = this.postFormSection.querySelector('section.show-subscribe');
this.main.pbu.replace(this.showSubscribeSection,
this.main.pbu.createCheckedInputElement({value:p.showSubscribe,isBool:true,clasz:['show-subscribe'],divClasz:['form-switch'],items:['Can Subscribe?']})
);
this.showSubscribeControl = this.showSubscribeSection.querySelector('input.show-subscribe');
//
this.allowShareSection = this.postFormSection.querySelector('section.allow-share');
this.main.pbu.replace(this.allowShareSection,
this.main.pbu.createCheckedInputElement({value:p.allowShare,isBool:true,clasz:['allow-share'],divClasz:['form-switch'],items:['Can Share?']})
);
this.allowShareControl = this.allowShareSection.querySelector('input.allow-share');
//
this.showExcerptSection = this.postFormSection.querySelector('section.show-excerpt');
this.main.pbu.replace(this.showExcerptSection,
this.main.pbu.createCheckedInputElement({value:p.showExcerpt,isBool:true,clasz:['show-excerpt'],divClasz:['form-switch'],items:['Show Excerpt?']})
);
this.showExcerptControl = this.showExcerptSection.querySelector('input.show-excerpt');
//
await updateView();
addEvents();
$this.checkRoles();
return this.postFormSection;

async function updateView(){
//title
$this.main.pbu.prependChild($this.postForm,$this.main.pbu.createFormControl({title:"Title",value:p.title,clasz:['title','sp-validation-required']}));
$this.postTitleControl = $this.postForm.querySelector('.title');
//featured image
$this.m.pb.getImageBlock({v:{src:p.featuredImageUrl}}).then(r=>$this.m.pbu.replace($this.featuredImageSection,r.querySelector('div.main-media-container')));
//content status
$this.main.pbu.appendChild($this.contentStatusDiv,
$this.main.pbu.createCheckedInputElement({id:"contentStatus",value:p.contentStatus,type:'radio',items:$this.main.config.CONTENT_STATUS}),
);

//
if($this.state.postType=='product'){
$this.main.pbu.show($this.productDataDiv);
}

if($this.state.postType=='post' || $this.state.postType=='product'){
$this.main.pbu.show($this.featuredImageSection);
$this.main.pbu.show($this.excerptSection);
$this.main.pbu.show($this.postCategoriesSection);
//categories
$this.renderCategories();
//tags
$this.processTags();
//keywords
$this.processKeywords();
$this.main.pbu.show($this.isFeaturedSection,$this.isStickySection,$this.allowCommentsSection);
//featured image
}//if
//sidebar type
$this.main.pbu.appendChild($this.sidebarTypeDiv,
$this.main.pbu.createSelectElement({id:"sidebarType",value:p.sidebarType,items:$this.main.config.SIDEBAR_LAYOUT})
);
$this.sidebarTypeSelector = $this.sidebarTypeSection.querySelector('#sidebarType');
//sidebarWidgets
$this.getSidebarWidgets();
//input
$this.pb.isView = $this.widget.isView = false;
$this.pb.pbInput = $this.post$.mainContent;
$this.main.pbu.replace($this.mainContentDiv,await $this.pb.getTemplate($this.state.type));

}//inner
function addEvents(){
$this.main.pbu.listen($this.excerptButton,'click',()=>{
let div = $this.main.pbu.createElement('div');
div.innerHTML = 
`
<textarea class="sp-excerpt form-control">${$this.post$.excerpt}</textarea>
`;
let modal = $this.main.utils.setModal('Post Excerpt',div);
$this.main.pbu.listen(modal.confirm,'click',()=>{
    //validate()
$this.post$.excerpt = div.querySelector('textarea.sp-excerpt').value;
modal.dismiss.click();   
},$this,[div,modal]);
});//listen
//category
$this.main.pbu.listen($this.createCategoryButton,'click',()=>{
    $this.createCategory();
});

//sidebar
$this.main.pbu.listen($this.sidebarTypeSelector,'change',()=>{
    if ($this.sidebarTypeSelector.value=='NONE'){
        $this.main.pbu.hide($this.sidebarWidgetsSection);
    }else{
        $this.main.pbu.show($this.sidebarWidgetsSection);
    }
});
}//inner
}//func

/**
 * 
 * @param {any|null} posts 
 */
async setListTable(posts=null){
let isPost = this.state.postType=='post';
let titles = ["Title","Category","Author","Views"];
if(!isPost){
    titles = ["Title","Views"];
}
let items = [];
let displayPosts = (posts)?posts: this.posts$.filter(p=>p.postType==this.state.postType);
let i;
for(let p of displayPosts){
i = {
id:p.id,
href:this.main.getHomeLink('post',p.postType,'s',p.title,p.id),
titles:[p.title,(p.category?.title)?p.category.title:'None',(p.author)?p.author.firstName:'',p.views],
editHref:this.main.getLink('post',p.postType,'edit',p.id),
deleteHref:``
};
if(!isPost){
    i = {
    id:p.id,
    href:this.main.getHomeLink('post',p.postType,'s',p.title,p.id),
    titles:[p.title,p.views],
    editHref:this.main.getLink('post',p.postType,'edit',p.id),
    deleteHref:``
};
}
items.push(i);
}//for
let menuTable = await this.main.pbu.createTable({titles:titles,posts:items});
this.main.pbu.replace(this.postListTableSection,menuTable);
}//func

async checkRoles(){
if(this.parent.adminUser.topRole=='CONTRIBUTOR'){
    let contentStatusInput = this.contentStatusDiv.querySelectorAll('input');
    for(let input of contentStatusInput){
        input.removeAttribute('checked');
        input.setAttribute('disabled','disabled');
        if(input.value=='DRAFT'){
            input.setAttribute('checked','checked');
        }
    }
    this.cleanups.push(()=>{contentStatusInput.remove(); contentStatusInput = null;});
}
}//func
/**
 * 
 * @param {string} filterTerm 
 * @param {string} type 
 */
filterPosts(filterTerm,type){
    //temporary rememdy for possibly event bubbling.......
    if(!filterTerm){return;}
    filterTerm = filterTerm.toLowerCase();
    type = type.toLowerCase();
    let displayPosts = this.posts$.filter(p=>p.postType==this.state.postType);
switch(type){
    case 'category':
        //note
        this.categoryFilterTerm = filterTerm;
        if(this.categoryFilterTerm=='all'){
            //do nothing
        }else{
            displayPosts = displayPosts.filter(p=>this.categoryFilterTerm==p.category?.title.toLowerCase());
        }

        if(this.statusFilterTerm=="all"){
           //do nothing
        }else{
            displayPosts = displayPosts.filter(p=>p.contentStatus.toLowerCase()==this.statusFilterTerm);
        }
        break;
    case 'status':
        //note
        this.statusFilterTerm = filterTerm;
        if(this.statusFilterTerm=='all'){
            //do nothing
        }else{
            displayPosts = displayPosts.filter(p=>p.contentStatus.toLowerCase()==this.statusFilterTerm);
        }

        if(this.categoryFilterTerm=='all'){
            //do nothing
        }else{
            //note: categoryFilterTerm = categoryTitle
            displayPosts = displayPosts.filter(p=>p.category?.title.toLowerCase()==this.categoryFilterTerm);
        }
        
        break;
}//switch

this.setListTable(displayPosts);
this.cleanups.push(()=>{displayPosts = null;});
}//func

/**
 * 
 * @param {string} searchTerm 
 */
searchPostList(searchTerm){
if(!this.main.vu.validate(this.searchTermControl)){
    return;
}

let regex = new RegExp(`${searchTerm}`, "i");
let displayPosts= this.posts$.filter(i=>regex.test(i.title));
//reset filter terms
this.categoryFilterTerm = this.statusFilterTerm =  'All';
this.setListTable(displayPosts);
this.cleanups.push(()=>{regex=displayPosts = null;});
}//func



getSidebarWidgets(){
let $this = this;
//init
if($this.post$.sidebarType==this.main.config.SIDEBAR_LAYOUT[0]){
    $this.main.pbu.hide($this.sidebarWidgetsSection);
}
else{
$this.main.pbu.show($this.sidebarWidgetsSection);
}//
this.cleanups.push(()=>{$this = null;});
showWidget();
addEvents();

/**
 * 
 * @param {string} name 
 */
async function showWidget(name = ''){
let widgets = [];
let defaultRecentPostsWidget = {m:'recentPosts',v:$this.m.pb.ep.recentPosts.data};
let defaultWidgets = [defaultRecentPostsWidget];
//do you have widgets saved already in the post
/**@type {any[]}*/let selectedSidebarWidgets = JSON.parse($this.post$.sidebarWidgets) || [];//saved
//no name from regular call from updateView()
if(name){
    //i.e when a widget is turned on on the sidebar
for(let widget of defaultWidgets){
    if(name==widget.m){
    //if editing a post and the post already have the selected widget
    //initilize the widget with it
        widgets = [widget];//only one will be shown
        break;
    }
    }//for
 
}else{
    //init: new or edit without clicking
    widgets = selectedSidebarWidgets;
}
let rpwTemplate;
for(let widget of widgets){
switch(widget.m){
            case 'recentPosts':
                $this.recentPostsWidgetControl.checked = 'true';
                rpwTemplate = await $this.widget.getTemplate('recentPosts',widget.v);
                $this.main.pbu.show($this.recentPostsWidgetSettingsDiv);
                $this.main.pbu.replace($this.recentPostsWidgetSettingsDiv,rpwTemplate.div);
                break;
            case 'categoryPosts':
                break;
        }//switch
    }//for
$this.cleanups.push(()=>{widgets=defaultRecentPostsWidget=defaultWidgets=selectedSidebarWidgets=rpwTemplate = null;});
}//inner

function addEvents(){
//recentPostsWidgetControl
        $this.main.pbu.listen($this.recentPostsWidgetControl,'change',()=>{
                if(!$this.recentPostsWidgetControl.checked){
                $this.main.pbu.hide($this.recentPostsWidgetSettingsDiv);
                return;
                }
                showWidget('recentPosts');
        },$this);
}//inner
}//func

setupMainForm(){
/**@type {any}*/let pbInput;
if(this.state.type=='edit' || this.state.type=='detail'){
pbInput = {
title:this.post$.title,
message:this.post$.mainContent,
contentStatus:this.post$.contentStatus
};
}
let pb = new PageBuilder(this.main,this);
let template = pb.getTemplate();
this.postForm.appendChild(template);
this.cleanups.push(()=>{pbInput=pb=template = null;});
}//

async createCategory2(){
let newCategory;
let state = this.m.getState(this.m.getLink('category','post','new',-1));
//incase of error
state.isModal = true;
state.isPartial = true;
state.stateObject = this.state.stateObject;//??
let categoryComponent = new Category(this.main,state);
categoryComponent.isPartial = true;
let template = await categoryComponent.getFormTemplate();
//temp: dont use this.m.modal for partial
let modal = this.main.utils.setModal('New Category',template,false,{confirmText:'Save',cb:async ()=>{
categoryComponent.state.notice=modal.notice;  
newCategory = await categoryComponent.save();
if(newCategory){
this.post$.category = newCategory;
this.categories$.push(newCategory);
this.renderCategories();
    this.main.utils.notify('Saved',{level:0,customMessageDiv:modal.notice});
}
}});
}//func

async createCategory(){
let newCategory;
let state = this.m.getState(this.m.getLink('category','post','new',-1));
//incase of error
state.isOffCanvas = true;
state.isPartial = true;
state.stateObject = this.state.stateObject;//??
let categoryComponent = new Category(this.main,state);
categoryComponent.isPartial = true;
let template = await categoryComponent.getFormTemplate();
this.m.pbu.getEventButton('Save',{cb:async()=>{
categoryComponent.state.notice=this.m.offCanvas.notice;  
newCategory = await categoryComponent.save();
if(newCategory){
this.post$.category = newCategory;
this.categories$.push(newCategory);
this.renderCategories();
    this.main.utils.notify('Saved',{level:0,customMessageDiv:this.m.offCanvas.notice});
}
},clasz:['w-100','w-md-auto']}).then(b=>this.m.pbu.appendChildIf(template,b));
//temp: dont use this.m.modal for partial
this.m.offCanvas = this.m.utils.setOffCanvas('New Category',template,{placement:'end'});
}//func

renderCategories(){
this.categoryTitles = this.categories$.map(c=>c.title);
this.postCategoriesDiv.innerHTML = '';
this.main.pbu.appendChild(this.postCategoriesDiv,
this.main.pbu.createSelectElement({id:"categoryTitle",value:this.post$.category?.id,postItems:[...this.categories$],clasz:['my-2'],default:'None'}));
//handle
this.categoryTitleSelector = this.postCategoriesDiv.querySelector('#categoryTitle');
}//func
/**
 * 
 * @param {HTMLInputElement} el 
 */
selectCategory(el){
let pcn = this.post$.categoryIds;//post categoory number
let status = el.checked;
let id = el.value;
if(status==true){
if(!pcn.includes(id)){
pcn.push(id);
}
}else{// checked == false
if(pcn.includes(id)){
let index = pcn.indexOf(id);
if(index >-1){
pcn?.splice(index, 1);
}

}
}
this.post$.categoryIds = pcn;
}//
//############# TAGS ######################
/**
 * 
 * @param {boolean} save 
 */
async processTags(save=false){
let $this = this;
if(save){
return (this.postTags.length>0)?this.postTags.join(this.m.config.SPLITTER):'';
}
//handle
this.postTagsSection = this.postFormSection.querySelector('section.tags');
this.postTagsListDiv = this.postTagsSection.querySelector('div.tags');
this.postTagsForm = this.postTagsSection.querySelector('form.tags');
this.tagIntendedList = this.postTagsSection.querySelector('ul.tags-intended');//for tags auto-complete
this.m.pbu.appendChildIf(this.postTagsForm,this.m.pbu.createFormControl({clasz:['tags']}));
this.main.pbu.show(this.postTagsSection);
//
this.postTags = [];
//test
//this.post$.tags = 'mike|*|eh|*|cc';
if(this.post$.tags){
    let tags = this.post$.tags.split(this.m.config.SPLITTER);
    for(let t of tags){
        this.postTags.push(this.m.utils.capitalize(t));
    }
}
render();
async function render() {
$this.postTagsListDiv.innerHTML = ''	;
for(let t of $this.postTags){
let button = await $this.m.pbu.ce(['button',['btn','btn-sm'],t,[{n:'type',v:'button'},{n:'data-item',v:t},{n:'ic',v:'file-x'}]],{serialize:false});
$this.main.pbu.appendChild($this.postTagsListDiv,button);
$this.m.pbu.listen(button,'click',()=>{
let tag =$this.m.pbu.getAttribute(button,'data-item').trim();
$this.main.utils.pop(tag,$this.postTags);
button.remove();
$this.main.log($this.postTags,'Post.processTags(): deleted post tags');
});
}//for
}//inner
//add button
this.m.pbu.getEventButton('Add',{cb:()=>{
let tagControl = $this.postTagsForm.querySelector('input');
if(!this.m.vu.lightValidate(tagControl)){return;}
let newTags = tagControl.value.trim().replaceAll(',',' ').split(' ');
for(let t of newTags){
$this.m.utils.push(this.postTags,this.m.utils.capitalize(t));
}
tagControl.value = '';
render();
this.main.log(this.postTags,'Post.processTags(): tags added');
}}).then(b=>this.m.pbu.appendChildIf(this.postTagsForm,b));
    ///
//auto-complete 
let searchTerm,tags;
this.tagsControl = this.postTagsForm.querySelector('input');
$this.main.pbu.listen($this.tagsControl,'input',()=>{
    if(!$this.main.vu.sanitize([$this.tagsControl])){return;}
    searchTerm = $this.tagsControl.value?.trim().toLowerCase();
    //is search in tags?
    tags = $this.postTags.filter(t=>t.includes($this.main.utils.capitalize(searchTerm)));
    $this.main.autoComplete($this.tagsControl,false,tags,'tag');
});
}//

/**
 * 
 * @param {boolean} save 
 * @returns 
 */
async processKeywords(save){
let $this = this;
if(save){
return (this.postKeywords.length>0)?this.postKeywords.join(this.m.config.SPLITTER):'';
}
//handle
this.postKeywordsSection = this.postFormSection.querySelector('section.keywords');
this.postKeywordsListDiv = this.postKeywordsSection.querySelector('div.keywords');
this.postKeywordsForm = this.postKeywordsSection.querySelector('form.keywords');
this.m.pbu.appendChildIf(this.postKeywordsForm,this.m.pbu.createFormControl({clasz:['keywords']}));
this.main.pbu.show(this.postKeywordsSection);
//
this.postKeywords = [];
//test
//this.post$.Keywords = 'mike|*|eh|*|cc';
if(this.post$.keywords){
    let keywords = this.post$.keywords.split(this.m.config.SPLITTER);
    for(let k of keywords){
        this.postKeywords.push(this.m.utils.capitalize(k));
    }
}
render();
async function render() {
$this.postKeywordsListDiv.innerHTML = ''	;
for(let k of $this.postKeywords){
let span = await $this.m.pbu.ce(['button',['btn','btn-sm'],k,[{n:'type',v:'button'},{n:'data-item',v:k},{n:'ic',v:'file-x'}]],{serialize:false});
$this.main.pbu.appendChild($this.postKeywordsListDiv,span);
$this.m.pbu.listen(span,'click',()=>{
let keyword =$this.m.pbu.getAttribute(span,'data-item').trim();
$this.main.utils.pop(keyword,$this.postKeywords);
span.remove();
$this.main.log($this.postKeywords,'Post.processKeywords(): updated post keywords');
});
}//for
}//inner

//add button
this.m.pbu.getEventButton('Add',{cb:()=>{
let keywordControl = $this.postKeywordsForm.querySelector('input');
if(!this.m.vu.lightValidate(keywordControl)){return;}
let newKeywords = keywordControl.value.trim().replaceAll(',',' ').split(' ');
for(let k of newKeywords){
$this.m.utils.push(this.postKeywords,this.m.utils.capitalize(k));
}
keywordControl.value = '';
render();
this.main.log(this.postKeywords,'Post.processKeywords(): keywords added');
}}).then(b=>this.m.pbu.appendChildIf(this.postKeywordsForm,b));
}//func

/**
 * 
 * @param {string} pbMessage 
 */
async save(pbMessage){
let $this = this;
if(!this.main.vu.validate(this.postTitleControl)){return;}
let title = this.main.utils.sanitizeTitle(this.postTitleControl.value,this.postTitleControl);
if(this.state.postType=='page' && this.state.type=='new' && this.main.config.RESERVED_TITLES.includes(title.toLowerCase())){
    this.main.utils.notify('This title is reserved',{level:1});
    return;
}
//process sidebar widgets
let sidebarWidgets = [];
let l,cat,we,wi,wm,m;
if(this.recentPostsWidgetControl.checked){
l = this.sidebarWidgetsSection.querySelector('.recent-posts-limit').value;
cat = this.sidebarWidgetsSection.querySelector('.recent-posts-category').value;
we = this.sidebarWidgetsSection.querySelector('.recent-posts-with-excerpt').checked;
wi = this.sidebarWidgetsSection.querySelector('.recent-posts-with-image').checked;
wm = this.sidebarWidgetsSection.querySelector('.recent-posts-with-meta').checked;
m = {
m:'recentPosts',
v:{
    m:'recentPosts',
    l:l,
    cat:this.main.utils.isNull(cat)?-1:cat,
    we:we,
    wi:wi,
    wm:wm
}
};

sidebarWidgets.push(m);
}
//let featuredImageUrl = (this.state.postType=='post')?await this.main.media.uploadToServer(this.featuredImageSection.querySelector('div.media-template')):''
//
let post = {
id:this.post$.id,
title:title,
slug:title.toLowerCase(),
mainContent:pbMessage,
excerpt:this.post$.excerpt,
postType:this.state.postType,
featuredImageUrl:this.featuredImageSection.querySelector('.main-media')?.src||'',
keywords:await this.processKeywords(true),
tags:await this.processTags(true),
likes:this.post$.likes,
views:this.post$.views,
contentStatus: this.contentStatusDiv.querySelector('input:checked').value.toUpperCase(),
allowComments:this.allowCommentsControl.checked,
allowShare:this.allowCommentsControl.checked,
showExcerpt:this.showExcerptControl.checked,
isFeatured:this.isFeaturedControl.checked,
isSticky:this.isStickyControl.checked,
showSubscribe:this.showSubscribeControl.checked,
sidebarType:this.sidebarTypeSelector.value.toUpperCase(),
sidebarWidgets:JSON.stringify(sidebarWidgets),
categoryId:(this.state.postType=='post')?this.categoryTitleSelector.value:null,
category:null,
authorId:this.post$.authorId /**important */
}
this.main.setTenant(post);
this.main.log(post,'Post.savePost(): Before submit');
let r = await this.main.fu.fetch({
    link:this.main.fu.getApi(this.state.url),
    body:JSON.stringify(post)
});
if(r>0){
//r = response = id of submitted post
post.id = r;//needed for preview link
this.main.utils.notify('Saved',{level:0});
this.state = this.main.replaceState(this.post$,this.state,r);
if(post.contentStatus=='PUBLISH'){
previewPost();
}

}
this.main.utils.finilizeSave(this);


async function previewPost(){
$this.m.pbu.replace($this.parent.postPreviewDiv,`<span>Saved</span><a target="_blank" href="${$this.main.getHomeLink('post',post.postType,'s',post.title,post.id)}" class="ms-4">View<i class="bi bi-arrow-right-short"></i></a>`,true);
setTimeout(() => {
$this.parent.postPreviewDiv.innerHTML = '';
}, 10000);
}//inner
}//submitPost

//###########
getNewPost(){
return {
id:-1,
title:"",
slug:"",
mainContent:"",
excerpt:"",
postType:"",
contentStatus:(this.parent.adminUser.topRole=='CONTRIBUTOR')?"DRAFT":"PUBLISH",
featuredImageUrl:"",
keywords:"",
tags:"",
likes:0,
views:0,
sidebarType:"NONE",
sidebarWidgets: "[]",
allowComments:false,
isFeatured:false,
isSticky:false,
showSubscribe:false,
allowShare:false,
showExcerpt:false,
categoryId:null,
category:null,
username:"",
tenantId:-1,
tenantUuid:''
};
}//newPost()

getItems(){
    return this.posts$;
}
/**
 * 
 * @param {any} items 
 */
async setItems(items){
this.state.stateObject.posts = items;
await this.setDisplay();
}//
}//class